/* eslint-disable no-console */
import type { IconSet } from '@iconify/tools'
import type { ExportOptions } from './types'
import { promises as fs } from 'node:fs'
import { dirname } from 'node:path'

/**
 * 导出图标集为 Iconify JSON 格式
 */
export async function exportIconSet(
  iconSet: IconSet,
  options: ExportOptions,
): Promise<void> {
  const { output, pretty = true } = options

  // 导出为 Iconify JSON
  const json = iconSet.export()

  // 确保输出目录存在
  const dir = dirname(output)
  await fs.mkdir(dir, { recursive: true })

  // 写入文件
  const content = pretty
    ? JSON.stringify(json, null, 2)
    : JSON.stringify(json)

  await fs.writeFile(output, content, 'utf-8')

  console.log(`💾 已保存到: ${output}`)
  console.log(`   图标数量: ${Object.keys(json.icons || {}).length}`)
}

/**
 * 导出为 UnoCSS collections 格式
 * 返回 { iconName: "svg string" } 格式
 *
 * 优化说明：
 * - 保持原始 viewBox 以维持设计意图
 * - 移除固定的 width/height 属性，让 CSS 控制显示尺寸
 * - 非正方形 icon（如品牌标识）会保持原始宽高比
 */
export function exportForUnoCSS(iconSet: IconSet): Record<string, string> {
  const json = iconSet.export()
  const icons: Record<string, string> = {}

  for (const [name, icon] of Object.entries(json.icons || {})) {
    const iconData = icon
    const width = iconData.width || 24
    const height = iconData.height || 24

    // 只设置 viewBox，不设置固定的 width/height
    // 这样可以通过 CSS 灵活控制显示大小，同时保持原始宽高比
    icons[name] = `<svg viewBox="0 0 ${width} ${height}">${iconData.body}</svg>`
  }

  return icons
}
